import * as processes from 'constants/enums/processes'

export default {
  [processes.DOCUMENTATION]: 'Obchodní dokumentace',
  [processes.APPROVAL]: 'Schvalování',
} as const
